module.exports = __webpack_public_path__ + "media/directory/settings_icon-1f92ef41.svg";